import React, {useEffect, useState} from 'react';
import Dashboard from "../../layouts/Dashboard";
import BreadcrumbsShared from "../../components/Shared/BreadcrumbsShared";
import {COMPLETION_ACT_ADD_ROUTE, COMPLETION_ACT_ROUTE} from "../../routes/const";
import Box from "@mui/material/Box";
import {Button} from "@mui/material";
import {useHistory} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {
    changeCompletionActState,
    getCompletionAct
} from "../../redux/actions/bookkeeping/bookkeepingActions";
import {useTranslation} from "react-i18next";
import {completionActTableRowName} from "../../lang/i18n";
import moment from "moment";
import {DeleteForeverIconCustom, TableCustom, VisibilityIconCustom} from "../../components";
import PopupExcel from "../../components/Popups/PopupExcel";

function CompletionAct(props) {
    const {t} = useTranslation();
    const rowName = [
        ...completionActTableRowName
    ]

    const [open, setOpen] = useState(false)
    const [id, setId] = useState(1)

    const history = useHistory()
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const dispatch = useDispatch()
    const {completionActs, completionActsCountTable} = useSelector((state) => state.bookkeeping);

    useEffect(() => {
        (async function () {
            dispatch(getCompletionAct(page + 1, rowsPerPage))
        }())
    }, [dispatch, page, rowsPerPage]);

    const openHandler = (value, id) => {
        return () => {
            setId(id)
            setOpen(value)
        }
    }

    const changeState = (id) => {
        return () => {
            dispatch(changeCompletionActState(id, 1, 2, page, rowsPerPage))
        }
    }

    return (
        <Dashboard>
            <BreadcrumbsShared breadcrumbs={[
                {text: 'Акты выполненных работ', link: COMPLETION_ACT_ROUTE}
            ]}/>
            <Box sx={{margin: '0 0 20px 0', display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                <Button onClick={() => history.push(COMPLETION_ACT_ADD_ROUTE)} color="primary"
                        variant="contained">{t("completionAct.buttonText")}</Button>
            </Box>
            <TableCustom rowsPerPage={rowsPerPage} setRowsPerPage={setRowsPerPage} page={page} setPage={setPage}
                         countRow={completionActsCountTable} name="Акты выполненных работ" avatars={false} rowName={rowName}
                         rows={completionActs && completionActs.map(el => {
                             return {
                                 id: el?.id,
                                 startDate: moment(el.startDate).format('LL'),
                                 name: el?.contract?.name,
                                 status: el?.state?.name,
                                 view: <Button onClick={openHandler(true, el?.id)} size="small" variant="contained">Смотреть</Button>,
                                 bookkeeping: el?.state?.id === 1 ? <Button onClick={changeState(el?.id)} size="small" color="warning" variant="contained">Отправить в бухгалтерию</Button> : 'Отправлено'
                             }
                         })} locale="contract" actions={[
                {icon: <VisibilityIconCustom/>, id: 'VisibilityIcon'},
                {icon: <DeleteForeverIconCustom/>, id: 'DeleteForeverIcon'}]}/>
            <PopupExcel id={id} open={open} handleClose={() => setOpen(false)}/>
        </Dashboard>
    );
}

export default CompletionAct;